import Image from './image'

export const AmuiImage = Image

export default Vue => Vue.component(Image.name, Image)
